<script>
export default {
  data() {
    return {
      productData: {},
      soloPressAttributes: null,
      solopressQuentityPayload: null,
      soloPressPricing: null,
      id: null,
    };
  },

  methods: {
    fetchProductDetails() {
      const loader = this.$loading.show({
        loader: "dots",
      });
      this.$store.getters.client.get("/catalog-product/get-catalog-product/" + this.id + "/").then((response) => {
        this.productData = response.data;
        this.initializeSolopressProduct();
        loader.hide();
      }).catch((err) => {
        loader.hide();
        alert(err);
      })
    },

    initializeSolopressProduct() {
      const payload = this.createSolopressPayload();
      this.soloPressAttributes = payload;
      this.solopressQuentityPayload = { ...payload, product: this.productData.solopress_name, quantity: 25, product_id: this.productData.id };

      // const response = await ProductApi.getSolopressPrice(this.solopressQuentityPayload);
      this.$store.getters.client.post("/solopress/prices/", this.solopressQuentityPayload).then((response) => {
        this.soloPressPricing = response.data.attribute_values.prices.map(item => ({
          ...item,
          margin: item.margin ? Number(item.margin) : 0,
        }));
      }).catch((err) => {
        console.error("Error fetching Solopress price:", err);
      });
    },

    createSolopressPayload() {
      return this.productData.associated_attribute.reduce((acc, item) => {
        const key = item.description.charAt(0).toLowerCase() + item.description.slice(1);
        acc[key] = isNaN(item.attribute_value[0].description)
          ? item.attribute_value[0].description
          : Number(item.attribute_value[0].description);
        return acc;
      }, {});
    },

    solopressQuentityPrice(quantity) {
      const payload = { ...this.solopressQuentityPayload, quantity };
      this.$store.getters.client.post("/solopress/prices/", payload).then((response) => {
        const result = response.data.attribute_values.prices.map(item => ({
          ...item,
          margin: item.margin ? Number(item.margin) : 0,
        }));
        const newPrices = result.filter(newItem => !this.soloPressPricing.some(oldItem => oldItem.quantity === newItem.quantity));
        this.soloPressPricing = [...this.soloPressPricing, ...newPrices];
      }).catch((err) => {
        console.error("Error fetching Solopress price:", err);
      });
    },
    async submitDetails() {
      await this.$validator.validateAll().then((result) => {
        if (result) {
          let loader = this.$loading.show({
            loader: "dots",
          });
          // const data = {}
          const payload = {};

          this.soloPressPricing.forEach(item => {
            payload[item.quantity] = Number(item.margin);
          });
          this.$store.getters.client.patch("/catalog-product/products/" + this.productData.id + "/", { solopress_margin: payload })
            .then(() => {
              loader.hide();
            }).catch((err) => {
              loader.hide();
              alert(err)
            });
        }
      });
    },
  },

  mounted() {
    this.fetchProductDetails();
  },

  created() {
    this.id = this.$route.params.id;
  },
};
</script>

<template>
  <div class="row">
    <div class="col-lg-9">
      <b-card :title="productData.solopress_name" class="mb-3">
        <b-table :items="soloPressPricing" :fields="['quantity', 'cheapest', 'medium', 'quickest', 'margin']"
          class="mb-0">
          <template #cell(quantity)="data">
            <span>{{ data.item.quantity }}</span>
          </template>
          <template #cell(cheapest)="data">
            <span>{{ data.item.cheapest }}</span>
          </template>
          <template #cell(medium)="data">
            <span>{{ data.item.medium }}</span>
          </template>
          <template #cell(quickest)="data">
            <span>{{ data.item.quickest }}</span>
          </template>
          <template #cell(margin)="data">
            <span>
              <b-form-input v-model="data.item.margin" type="number" style="width: 100px;" />
            </span>
          </template>
        </b-table>
        <div class="d-flex justify-content-end align-items-center mt-3 gap-3">
          <b-button class="ml-2" @click="solopressQuentityPrice(soloPressPricing[0].quantity)">Less Quentity</b-button>
          <b-button class="ml-2" @click="solopressQuentityPrice(soloPressPricing[soloPressPricing.length - 1].quantity)">More Quentity</b-button>
          <b-button variant="primary" class="ml-2" @click="submitDetails">Apply Margin</b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<style>
.invalid-input {
  border-color: red !important;
}

.small-input {
  -moz-appearance: textfield;
}

.small-input::-webkit-inner-spin-button {
  display: none;
}

.small-input::-webkit-outer-spin-button,
.small-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>